export const defaultSettings = {
  id: 0,
  name: "",
  destination: "",
  absoluteURI: "",
  selected: true,
  renderStatus: 0,
  settings: {
    segmented: false,
    segmentedTime: 10,
    standalone: false,
    avd: false,
    glyphs: false,
    includeExtraChars: false,
    bundleFonts: false,
    inlineFonts: false,
    hiddens: true,
    original_assets: true,
    original_names: true,
    should_encode_images: false,
    should_compress: false,
    should_skip_images: false,
    should_reuse_images: false,
    should_include_av_assets: true,
    compression_rate: 80,
    extraComps: {
      active: false,
      list: [],
    },
    guideds: false,
    ignore_expression_properties: false,
    export_old_format: false,
    use_source_names: false,
    shouldTrimData: false,
    skip_default_properties: false,
    not_supported_properties: true,
    pretty_print: false,
    useCompNamesAsIds: false,
    export_mode: 'standard',
    export_modes: {
      standard: true,
      demo: false,
      standalone: false,
      banner: false,
      avd: false,
      smil: false,
      rive: false,
      reports: false,
    },
    demoData: {
      backgroundColor: "#ffffff",
    },
    banner: {
      lottie_origin: "local",
      lottie_path: "https://",
      lottie_library: "full",
      lottie_renderer: "svg",
      width: 1920,
      height: 1080,
      use_original_sizes: true,
      original_width: 1920,
      original_height: 1080,
      click_tag: "https://",
      zip_files: true,
      shouldIncludeAnimationDataInTemplate: false,
      shouldLoop: false,
      loopCount: 0,
      localPath: null,
    },
    expressions: {
      shouldBake: true,
      shouldCacheExport: false,
      shouldBakeBeyondWorkArea: false,
      sampleSize: 1,
    },
    audio: {
      isEnabled: true,
      shouldRaterizeWaveform: true,
      bitrate: "__bodymovin_sound_template_320",
    },
    metadata: {
      includeFileName: false,
      customProps: [],
    },
    template: {
      active: false,
      id: 0,
      errors: [],
    },
    essentialProperties: {
      active: true,
      useSlots: false,
      skipExternalComp: false,
    },
  },
};
